import { render, staticRenderFns } from "./editTelegram.vue?vue&type=template&id=a8c449c2&scoped=true"
import script from "./editTelegram.vue?vue&type=script&lang=js"
export * from "./editTelegram.vue?vue&type=script&lang=js"
import style0 from "./editTelegram.vue?vue&type=style&index=0&id=a8c449c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c449c2",
  null
  
)

export default component.exports